export const DARK: Record<string,string> = {
  '--bg-base':          '#070b13',
  '--bg-card':          '#0c1322',
  '--bg-card-alt':      '#0f1726',
  '--bg-input':         '#070b13',
  '--bg-hover':         '#111d30',
  '--bg-active':        '#172444',
  '--border':           '#1a2940',
  '--border-active':    '#1e3f72',
  '--text-primary':     '#f0f4ff',
  '--text-secondary':   '#c9d4e8',
  '--text-muted':       '#5f7494',
  '--text-faint':       '#3d5270',
  '--text-dimmed':      '#243448',
  '--accent':           '#4f8ef7',
  '--accent-bg':        '#0e1f42',
  '--accent-glow':      'rgba(79,142,247,0.15)',
  '--success':          '#2dd4a0',
  '--success-bg':       '#031f16',
  '--warning':          '#f6b93b',
  '--warning-bg':       '#231a04',
  '--danger':           '#f06b6b',
  '--danger-bg':        '#200a0a',
  '--purple':           '#a78bfa',
  '--purple-bg':        '#130f26',
  '--sidebar-bg':       '#080e1c',
  '--header-bg':        '#0c1322',
  '--shadow-sm':        '0 1px 3px rgba(0,0,0,0.4)',
  '--shadow-md':        '0 4px 16px rgba(0,0,0,0.5)',
  '--shadow-lg':        '0 8px 32px rgba(0,0,0,0.6)',
};

export const LIGHT: Record<string,string> = {
  '--bg-base':          '#f0f4f8',
  '--bg-card':          '#ffffff',
  '--bg-card-alt':      '#f8fafc',
  '--bg-input':         '#f8fafc',
  '--bg-hover':         '#f1f5f9',
  '--bg-active':        '#e8f0fe',
  '--border':           '#dde5f0',
  '--border-active':    '#93b4f5',
  '--text-primary':     '#0d1828',
  '--text-secondary':   '#1e3352',
  '--text-muted':       '#4a6080',
  '--text-faint':       '#7a92ae',
  '--text-dimmed':      '#b0c0d4',
  '--accent':           '#2563eb',
  '--accent-bg':        '#dbeafe',
  '--accent-glow':      'rgba(37,99,235,0.08)',
  '--success':          '#059669',
  '--success-bg':       '#d1fae5',
  '--warning':          '#d97706',
  '--warning-bg':       '#fef3c7',
  '--danger':           '#dc2626',
  '--danger-bg':        '#fee2e2',
  '--purple':           '#7c3aed',
  '--purple-bg':        '#ede9fe',
  '--sidebar-bg':       '#1a3560',
  '--header-bg':        '#ffffff',
  '--shadow-sm':        '0 1px 3px rgba(0,30,80,0.08)',
  '--shadow-md':        '0 4px 16px rgba(0,30,80,0.10)',
  '--shadow-lg':        '0 8px 32px rgba(0,30,80,0.12)',
};

export type Theme = 'dark' | 'light';

export function applyTheme(theme: Theme) {
  const vars = theme === 'dark' ? DARK : LIGHT;
  Object.entries(vars).forEach(([k,v]) => document.documentElement.style.setProperty(k,v));
  document.documentElement.setAttribute('data-theme', theme);
  localStorage.setItem('folios_theme', theme);
}

export function loadTheme(): Theme {
  return (localStorage.getItem('folios_theme') as Theme) || 'dark';
}
